import { Card } from '@ipfabric/ui-components/Card/Card';
import { Link } from '@ipfabric/ui-components/Link/Link';
import { ListDivider } from '@ipfabric/ui-components/List/ListDivider/ListDivider';
import { createFormSnippetGroup } from '@ipfabric/ui-components/utils/formSnippets/FormSnippetGroup';
import { DEFAULT_APP_SETTING } from '@ipfabric/utils';
import { duplicateIpList } from '../../../snippets/discovery/duplicateIpList';
import { ipScopeExclude } from '../../../snippets/discovery/ipScopeExclude';
import { ipScopeInclude } from '../../../snippets/discovery/ipScopeInclude';
import { ipSeedList } from '../../../snippets/discovery/ipSeedList';

export const scopeDefinition = createFormSnippetGroup({
  snippets: {
    ipScopeInclude,
    ipSeedList,
    ipScopeExclude,
    duplicateIpList,
  },
  render: ({ renderSnippet, form }) => (
    <>
      <Card className='p flex flex-col gap'>
        <div className='flex flex-row gap-xs'>
          <div className='text-default text-level-5 font-semibold font-heading'>
            IP scope
          </div>
          <Link
            renderAs='button'
            onClick={() => {
              form.setValue('ipScopeInclude', {
                ips: DEFAULT_APP_SETTING.networks.include,
              });
              form.setValue('ipScopeExclude', {
                ips: DEFAULT_APP_SETTING.networks.exclude,
              });
              form.setValue('duplicateIpList', {
                ips: DEFAULT_APP_SETTING.networks.whitelist,
              });
            }}
          >
            Reset to default values
          </Link>
        </div>
        <div className='text-sm text-default'>
          <p className='font-semibold mb-1'>
            You can limit discovery and analysis range to one or more subnets
            with include and exclude option.
          </p>
          <p>
            Include means which parts of the network will be discovered and
            analyzed. No other part of the network than the one specified in
            include field won't be discovered or analyzed. Exclude strictly
            defines which part of the network won't be discovered or analyzed.
            Exclude option takes precedence over include.
          </p>
        </div>
        {renderSnippet('ipScopeInclude')}
        <ListDivider />
        {renderSnippet('ipScopeExclude')}
        <ListDivider />
        {renderSnippet('duplicateIpList')}
      </Card>
      <Card className='p flex flex-col gap'>
        <div className='flex flex-row gap-xs'>
          <div className='text-default text-level-5 font-semibold font-heading'>
            IP seeds
          </div>
          <Link
            renderAs='button'
            onClick={() => {
              form.setValue('ipSeedList', {
                ips: DEFAULT_APP_SETTING.discoverySeedIpList,
              });
            }}
          >
            Reset to default values
          </Link>
        </div>
        <div className='text-default text-sm'>
          A discovery seed is a device from which IP Fabric begins the
          auto-discovery process. These IPs can be device management IP
          addresses or networks. Discovery seed settings do not include or
          exclude any networks from discovery.
        </div>
        {renderSnippet('ipSeedList')}
      </Card>
    </>
  ),
});
